import { FormattedMessage } from 'react-intl';
import { useState, useEffect } from 'react';
import { Box, Drawer, Typography, Tabs, Tab } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import LiveFormValuesPreviewTable from './tools/LiveFormValuesPreviewTable';

import LiveFormPermissionsPreviewTable from './tools/LiveFormPermissionsPreviewTable';

function FormDebugWindow() {
  // Check if URL param 'debug' is 1 or 0
  const [searchParams, setSearchParams] = useSearchParams();
  const debugParam = searchParams.get('debug');

  const [open, setOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const toggleDrawer = () => {
    setOpen(prev => !prev);
    setSearchParams({});
  };

  useEffect(() => {
    setOpen(debugParam === 'MDCHK');
  }, [searchParams]);

  if (debugParam !== 'MDCHK') {
    return null;
  }

  return (
    <>
      {/* Left Drawer */}
      <Drawer
        ModalProps={{
          disableEnforceFocus: true,
        }}
        hideBackdrop
        anchor="left"
        open={open}
        sx={{
          pointerEvents: 'none', // allow clicks through container
          '& .MuiDrawer-paper': {
            pointerEvents: 'auto', // but keep drawer interactive
          },
        }}
        onClose={toggleDrawer}>
        <Box sx={{ width: 880, p: 2 }} role="presentation">
          <Typography variant="h6" gutterBottom>
            <FormattedMessage id="DEBUG" defaultMessage="Debug" />
          </Typography>

          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="debug tabs"
            sx={{ mb: 2 }}>
            <Tab label="Form Values" />
            <Tab label="Permissions" />
          </Tabs>
          {tabIndex === 0 && (
            <Box>
              <LiveFormValuesPreviewTable />
            </Box>
          )}
          {tabIndex === 1 && (
            <Box>
              <LiveFormPermissionsPreviewTable />
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
}

export default FormDebugWindow;
